import { render, staticRenderFns } from "./WithdrawIsAllowModal.vue?vue&type=template&id=2e3426d5&scoped=true&"
import script from "./WithdrawIsAllowModal.vue?vue&type=script&lang=js&"
export * from "./WithdrawIsAllowModal.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawIsAllowModal.vue?vue&type=style&index=0&id=2e3426d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3426d5",
  null
  
)

export default component.exports